export default __webpack_public_path__ + "static/media/suite-montanha1-main.b15f9e29.jpg";